module.exports = __webpack_public_path__ + "media/bootstrap-icons/terminal-fill-443e7dc3.svg";